import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=a4b06b00&scoped=true"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=a4b06b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b06b00",
  null
  
)

export default component.exports